import React from "react";
import { Link } from "react-router-dom";
import logo from "../../assets/images/web_logo.png";
import { TiSocialFacebook, TiSocialLinkedin, TiSocialTwitter } from "react-icons/ti";
import { IoShareSocialSharp } from "react-icons/io5";

const socialIcons = [
  <TiSocialFacebook size={20} color="#3d0000" />,
  <TiSocialLinkedin size={20} color="#3d0000" />,
  <TiSocialTwitter size={20} color="#3d0000" />,
  <IoShareSocialSharp size={20} color="#3d0000" />,
];

const Footer = () => {
  return (
    <footer className="bg-gradient-to-r from-blue-100 to-blue-300 text-white font-[Poppins] px-4 md:px-12 py-12">
      <div className="max-w-7xl mx-auto">
        <div className="bg-[#3d0000] rounded-2xl p-6 md:p-10 shadow-lg grid grid-cols-1 md:grid-cols-3 gap-10 text-white">
          
          {/* Logo & About */}
          <div>
            <img
              src={logo}
              alt="Logo"
              className="w-16 h-16 rounded-full"
            />
            <h4 className="font-semibold text-xl mt-6">Sansar Sadasya</h4>
            <p className="text-base mt-3">
              At bibendum est consectetur et magna. Eget felis in arcu a velit
              dictum eget hendrerit.
            </p>
            <div className="mt-4 text-base">
              <p className="font-semibold">Contact Us:</p>
              <a href="mailto:support@sansarsadasya.com" className="hover:underline text-white">
                support@sansarsadasya.com
              </a>
            </div>
            <div className="mt-4 text-base">
              <Link to="/privacy-policy" className="hover:underline text-white">
                Privacy Policy
              </Link>
            </div>
          </div>

          
          <div>
            <h4 className="font-semibold text-xl">Social Links</h4>
            <div className="flex gap-4 mt-5">
              {socialIcons.map((icon, index) => (
                <div
                  key={index}
                  className="h-10 w-10 bg-white bg-opacity-20 hover:bg-opacity-40 rounded-full flex items-center justify-center transition duration-300"
                >
                  {icon}
                </div>
              ))}
            </div>
          </div>

          
          <div>
            <h4 className="font-semibold text-xl">Join Our Family Today!</h4>
            <p className="text-base mt-3">
              At Sansar Sadasya E-Commerce Pvt. Ltd., we’re more than just a
              service provider—we’re your partner in managing daily life,
              helping you with the little things that make all the difference.
              Download our app today, and let’s build a stronger family bond
              together!
            </p>
          </div>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
